module.exports = __webpack_public_path__ + "static/media/CT_2019_30460_pdf.501dc17e.pdf";